import { useMemo, useState } from "react";
import FlightMulticityOfferDisplay from "../../../../components/flight/FlightMulticityOfferDisplay";
import FlightOfferDisplayV2 from "../../../../components/flight/FlightOfferDisplay-v2";
import Icon from "../../../../components/HOC/Icon";
import { decrypt } from "../../../../features/utils/crypto";
import { useSearchParams } from "react-router-dom";

export const SortedOffers = ({
    cat,
    obj,
    offer,
    index,
    params: { qIndex, searchObj, showDetail, handleOfferSelect, ...restParams },
  }) => {
    const [view, setView] = useState(false);
    console.log(" --> ", searchObj);
  
    let flightType = "One way";
    const destiny = searchObj?.destinations;
    if (destiny?.length > 1) {
      flightType = "Multi City";
      if (destiny?.length === 2) {
        if (
          destiny?.at(0)?.departureLocation === destiny?.at(-1)?.arrivalLocation
        )
          flightType = "Return";
      }
    }
  
    const FlightDisplayType =
      flightType === "Multi City"
        ? FlightMulticityOfferDisplay
        : FlightOfferDisplayV2;
  
    return (
      <div className="">
        <FlightDisplayType key={obj?.objects[0]?.id}
          path={qIndex}
          index={index}
          offer={offer}
          data={obj?.objects[0]}
          showDetail={async () => await showDetail(obj)}
          select={handleOfferSelect}
        />
        {/* <FlightOfferDisplayV2
          path={qIndex}
          index={index}
          offer={offer}
          data={obj?.objects[0]}
          showDetail={async () => await showDetail(obj)}
          select={handleOfferSelect}
        /> */}
        {obj.objects.length > 1 && !obj.chosen ? (
          <div
            className={
              "flex flex-col gap-4 relative  " + (view ? "bg-[#F3F7FF] " : "")
            }
          >
            <div
              className={
                "absolute -translate-y-[12px] p-2 w-full " +
                (view ? "bg-[#f3f7ff]" : "")
              }
            ></div>
            <div className="relative flex flex-col gap-2 mb-4">
              <button
                className={
                  "text-sm text-theme1 font-bold self-center shadow-inner border border-b-0 absolute bottom-0 max-h-[1.3rem] rounded-t-lg  pt-2 w-[50%] " +
                  (view ? "bg-[#F3F7FF]" : "bg-secondary")
                }
                onClick={() => setView(!view)}
              >
                <div
                  className={
                    "px-4 pb-2 rounded-lg " +
                    (view ? "bg-[#F3F7FF]" : "bg-secondary")
                  }
                >
                  {view ? (
                    `Hide flights`
                  ) : (
                    <span>
                      {obj.objects.length - 1} more{" "}
                      <span className="hidden md:inline">
                        flight options available at this price
                      </span>
                    </span>
                  )}
                </div>
              </button>
            </div>
            {view ? (
              <div className="flex flex-col gap-4 p-3">
                {obj.objects.slice(1).map((obj, i) => (
                  <FlightDisplayType
                    key={obj?.id || i}
                    index={index}
                    path={qIndex}
                    offer={offer}
                    data={obj}
                    showDetail={async () => showDetail && (await showDetail(obj))}
                    select={handleOfferSelect}
                    {...restParams}
                  />
                ))}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  };
  
  export function rearrageFlight(array, lastPath) {
    const airlinesMatch = (cur, prev) => {
      try {
        let curAirlines = [
          ...new Set(
            cur?.segments
              ?.map((obj) => obj.flights)
              .flat()
              .map((obj) => obj.marketingCarrier)
          ),
        ];
        let prevAirlines = [
          ...new Set(
            prev?.segments
              ?.map((obj) => obj.flights)
              .flat()
              .map((obj) => obj.marketingCarrier)
          ),
        ];
        if (curAirlines.length === prevAirlines.length)
          if (curAirlines.every((val) => prevAirlines.includes(val))) return true;
      } catch (ex) {}
  
      return false;
    };
    const result = array?.reduce((acc, cur, ind) => {
      if (
        ind > (lastPath ? 1 : 0) &&
        cur.totalAmount === array[ind - 1].totalAmount &&
        airlinesMatch(cur, array[ind - 1])
      ) {
        const prev = acc?.at(-1);
        prev.objects.push(cur);
      } else acc.push({ airline: "", price: "", objects: [cur] });
  
      return acc;
    }, []);
  
    return result;
  }
  
  export function MobileSearchUtils({setOpenSort,setOpenSearch,setOpenFilter}) {
    const [searchParam] = useSearchParams();
    const q = useMemo(() => searchParam.get("q"), [searchParam]);
    const searchObj = JSON.parse(decrypt(q));

    return (
        <div className="flex md:hidden bg-secondary w-full self-end sticky bottom-0 border-t shadow z-10">
            <div
            className="bg-primary/10 flex-1 p-5 flex justify-center items-center cursor-pointer"
            onClick={() => setOpenSort(true)}
            >
                <span className="flex gap-2">
                    <Icon icon="iconoir:sort" />
                    <span className="hidden sm:block">Sort</span>
                </span>
            </div>
            <div
                className="w-[50%] flex flex-col items-center justify-center cursor-pointer"
                onClick={() => setOpenSearch(true)}
                >
                <div className="flex gap-4">
                    <span>{searchObj?.destinations[0]?.departureLocation}</span>
                    <span>
                    <Icon icon="el:plane" className="text-theme1 py-[2px]" />
                    </span>
                    <span>{searchObj?.destinations[0]?.arrivalLocation}</span>
                </div>
                Change
            </div>
            <div
                className="flex flex-col items-center justify-center bg-primary/10 flex-1 p-5 cursor-pointer"
                onClick={() => setOpenFilter(true)}
                >
                <span className="flex gap-2">
                    <Icon icon="icon-park:setting-config" />
                    <span className="hidden sm:block">Filter</span>
                </span>
            </div>
        </div>
    )
  }